import './App.css';
import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Routes, Route } from "react-router-dom";
import PrivateRoute from './routes/PrivateRoute';
import MainLayout from "./components/layout/MainLayout";
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import Unauthorized from "./components/layout/Unauthorized";
import PageNotFound from "./components/layout/PageNotFound";
import AdminLayout from "./components/layout/AdminLayout";
import UserLayout from "./components/layout/UserLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserDashboard from "./pages/user/UserDashboard";
import HomePage from "./components/home/Home";
import SolarIndex from "./pages/solarPartner/SolarIndex";
import SolarView from "./pages/solarPartner/SolarView";
import BillingIndex from "./pages/billing/BillingIndex";
import BillingView from "./pages/billing/BillingView";  
import Setting from './pages/setting/Setting';
import City from './pages/city/City';
import Country from './pages/country/Country';
import State from './pages/state/State';
import Currancy from './pages/currancy/Currancy';
import SupportTicket from './pages/supportTicket/SupportTicket';
import SupportTicket1 from './pages/supportTicket/SupportTicket1';
import UserRole from './pages/userRole/UserRole';
import UserRole1 from './pages/userRole/UserRole1';
import SubscriptionIndex from './pages/subscription/SubscriptionIndex';
import SubscriptionCreate from './pages/subscription/SubscriptionCreate';
import SubscriptionView from './pages/subscription/SubscriptionView';
import UserView from './pages/userRole/UserView';
import LeadManage from './pages/leadManage/LeadManage';
import ItemManage from './pages/itemManage/ItemManage';
import GeneralSetting from './pages/generalSetting/GeneralSetting';
import QuotationSetting from './pages/quotationSetting/QuotationSetting';
import Item from './pages/item/ItemIndex';
import ItemCreate from './pages/item/ItemCreate';
import ItemView from './pages/item/ItemView';
import Lead from './pages/lead/LeadIndex';
import LeadCreate from './pages/lead/LeadCreate';
import LeadView from './pages/lead/LeadView';
import Quotation from './pages/quotation/QuotationIndex';
import QuotationCreate from './pages/quotation/QuotationCreate';
import QuotationView from './pages/quotation/QuotationView';
import Followup from './pages/followup/Followup';
import RoleCreate from './pages/userRole/RoleCreate';
import RoleCreate1 from './pages/userRole/RoleCreate1';
import Visit from './pages/visit/VisitIndex';
import VisitView from './pages/visit/VisitView';
import Bom from './pages/bom/BomIndex';
import BomCreate from './pages/bom/BomCreate';
import BomView from './pages/bom/BomView';
import { hasAccess } from "./utils/permissionHelper";

function App() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const readUserFromStorage = () => {
            try {
                const storedUser = localStorage.getItem("user");
                if (storedUser) {
                    setUser(JSON.parse(storedUser));
                } else {
                    setUser(false);
                }
            } catch (err) {
                console.error("Failed to read/parse user from localStorage:", err);
                setUser(false);
            }
        };

        readUserFromStorage();

        const onUserChanged = () => readUserFromStorage();
        const onStorage = (e) => {
            if (!e) return;
            if (e.key === "user") readUserFromStorage();
        };

        window.addEventListener("userChanged", onUserChanged);
        window.addEventListener("storage", onStorage);

        return () => {
            window.removeEventListener("userChanged", onUserChanged);
            window.removeEventListener("storage", onStorage);
        };
    }, []);

    if (user === null) {
        return <div>Loading...</div>;
    }

    return (
        <Routes>
            <Route element={<MainLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
            </Route>

            <Route
                path="/dashboard"
                element={
                    <PrivateRoute allowedRoles={["SuperAdmin"]}>
                        <AdminLayout />
                    </PrivateRoute>
                }
            >
                <Route index element={<AdminDashboard />} />
                
                {/* Solar Partners */}
                {hasAccess(user, "Solar Partners", "List") && (
                    <Route path="solar" element={<SolarIndex />} />
                )}
                {hasAccess(user, "Solar Partners", "View") && (
                    <Route path="solar/view/:id" element={<SolarView />} />
                )}

                {/* Billing */}
                {hasAccess(user, "Billing", "List") && (
                    <Route path="billing" element={<BillingIndex />} />
                )}
                {hasAccess(user, "Billing", "View") && (
                    <Route path="billing/view/:id" element={<BillingView />} />
                )}

                {/* Settings, city, country, state */}
                {hasAccess(user, "General-Setting", "List") && (
                    <Route path="setting" element={<Setting />} />
                )}
                {hasAccess(user, "City", "List") && (
                    <Route path="city" element={<City />} />
                )}
                {hasAccess(user, "State", "List") && (
                    <Route path="state" element={<State />} />
                )}
                {hasAccess(user, "Country", "List") && (
                    <Route path="country" element={<Country />} />
                )}
                {hasAccess(user, "Currancy", "List") && (
                    <Route path="currancy" element={<Currancy />} />
                )}

                {/* Support Ticket */}
                {hasAccess(user, "Support Ticket", "List") && (
                    <Route path="supportTicket" element={<SupportTicket />} />
                )}

                {/* User Role */}
                {hasAccess(user, "Role", "List") && (
                    <Route path="userRole" element={<UserRole1 />} />
                )}
                {hasAccess(user, "Role", "View") && (
                    <Route path="userRole/view/:id" element={<UserView />} />
                )}
                {hasAccess(user, "Role", "Create") && (
                    <Route path="userRole/create" element={<RoleCreate1 />} />
                )}
                {hasAccess(user, "Role", "Edit") && (
                    <Route path="userRole/edit/:id" element={<RoleCreate1 />} />
                )}

                {/* Subscription */}
                {hasAccess(user, "Subscription", "List") && (
                    <Route path="subscription" element={<SubscriptionIndex />} />
                )}
                {hasAccess(user, "Subscription", "Create") && (
                    <Route path="subscription/create" element={<SubscriptionCreate />} />
                )}
                {hasAccess(user, "Subscription", "View") && (
                    <Route path="subscription/view/:id" element={<SubscriptionView />} />
                )}
                {hasAccess(user, "Subscription", "Edit") && (
                    <Route path="subscription/edit/:id" element={<SubscriptionCreate />} />
                )}
            </Route>

            {/* User protected routes with permission check */}
            <Route
                path="/user"
                element={
                    <PrivateRoute allowedRoles={["Company Admin"]}>
                        <UserLayout />
                    </PrivateRoute>
                }
            >
                <Route index element={<UserDashboard />} />

                {/* User Role */}
                {hasAccess(user, "User", "List") && (
                    <Route path="userRole" element={<UserRole />} />
                )}
                {hasAccess(user, "User", "View") && (
                    <Route path="userRole/view/:id" element={<UserView />} />
                )}
                {hasAccess(user, "User", "Create") && (
                    <Route path="userRole/create" element={<RoleCreate />} />
                )}
                {hasAccess(user, "User", "Edit") && (
                    <Route path="userRole/edit/:id" element={<RoleCreate />} />
                )}

                {/* Lead */}
                {hasAccess(user, "Lead", "List") && (
                    <Route path="leadManage" element={<LeadManage />} />
                )}
                {hasAccess(user, "Lead", "List") && (
                    <Route path="lead" element={<Lead />} />
                )}
                {hasAccess(user, "Lead", "Create") && (
                    <Route path="lead/create" element={<LeadCreate />} />
                )}
                {hasAccess(user, "Lead", "Edit") && (
                    <Route path="lead/edit/:id" element={<LeadCreate />} />
                )}
                {hasAccess(user, "Lead", "View") && (
                    <Route path="lead/view/:id" element={<LeadView />} />
                )}
                {hasAccess(user, "Lead", "Followup") && (
                    <Route path="followup" element={<Followup />} />
                )}
                {hasAccess(user, "Lead", "Visit") && (
                    <Route path="visit" element={<Visit />} />
                )}
                {hasAccess(user, "Lead", "Visit") && (
                    <Route path="visit/view/:id" element={<VisitView />} />
                )}

                {/* Item */}
                {hasAccess(user, "Item", "List") && (
                    <Route path="itemManage" element={<ItemManage />} />
                )}
                {hasAccess(user, "Item", "List") && (
                    <Route path="item" element={<Item />} />
                )}
                {hasAccess(user, "Item", "Create") && (
                    <Route path="item/create" element={<ItemCreate />} />
                )}
                {hasAccess(user, "Item", "Edit") && (
                    <Route path="item/edit/:id" element={<ItemCreate />} />
                )}
                {hasAccess(user, "Item", "View") && (
                    <Route path="item/view/:id" element={<ItemView />} />
                )}

                {/* ItemBom */}
                {hasAccess(user, "ItemBom", "List") && (
                    <Route path="bom" element={<Bom />} />
                )}
                {hasAccess(user, "ItemBom", "Create") && (
                    <Route path="bom/create" element={<BomCreate />} />
                )}
                {hasAccess(user, "ItemBom", "Edit") && (
                    <Route path="bom/edit/:id" element={<BomCreate />} />
                )}
                {hasAccess(user, "ItemBom", "View") && (
                    <Route path="bom/view/:id" element={<BomView />} />
                )}

                {/* Quatation */}
                {hasAccess(user, "Quatation", "List") && (
                    <Route path="quotation" element={<Quotation />} />
                )}
                {hasAccess(user, "Quatation", "Create") && (
                    <Route path="quotation/create" element={<QuotationCreate />} />
                )}
                {hasAccess(user, "Quatation", "Edit") && (
                    <Route path="quotation/edit/:id" element={<QuotationCreate />} />
                )}
                {hasAccess(user, "Quatation", "View") && (
                    <Route path="quotation/view/:id" element={<QuotationView />} />
                )}
                {hasAccess(user, "Quatation-Setting", "List") && (
                    <Route path="quotationSetting" element={<QuotationSetting />} />
                )}

                {/* General Setting */}
                
                    <Route path="generalSetting" element={<GeneralSetting />} />
                

                {/* Currancy */}
                {hasAccess(user, "Currancy", "List") && (
                    <Route path="currancy" element={<Currancy />} />
                )}

                {/* Support Ticket 1 for Quatation */}
                {hasAccess(user, "Quatation", "List") && (
                    <Route path="supportTicket1" element={<SupportTicket1 />} />
                )}
            </Route>

            {/* Common dashboard for all authenticated users */}
            <Route
                path="/dashboard"
                element={
                    <PrivateRoute allowedRoles={["Company Admin", "SuperAdmin"]}>
                        <HomePage />
                    </PrivateRoute>
                }
            />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default App;